export default "__VITE_ASSET__dbc4cfed__"